export const payerTypes = [
  { name: "Commercial", value: "Commercial" },
  { name: "Medicare Advantage", value: "UhcMedicareAdvantage" },
  { name: "Medicare", value: "OriginalMedicare" },
  { name: "Medicaid", value: "Medicaid" },
];
